import { motion } from "framer-motion";
import {
  Sparkles, ScanLine, Smile, Activity, Baby, Crown, Droplets, Scissors,
} from "lucide-react";

export const PHONE = "0711 981 550";
export const PHONE_LINK = "tel:0711981550";
export const WHATSAPP_LINK =
  "https://wa.me/40711981550?text=Bun%C4%83%20ziua!%20A%C8%99%20dori%20o%20programare%20la%20MEDAS%20Stomatologie.";
export const ADDRESS = "Str. Letea 25, 300425 Timișoara";
export const MAPS_LINK =
  "https://www.google.com/maps/search/?api=1&query=Strada+Letea+25+Timisoara";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1777331903190-341a3dd0441b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxiZWF1dGlmdWwlMjBoZWFsdGh5JTIwc21pbGUlMjB0ZWV0aCUyMHdoaXRlbmluZyUyMGRlbnRpc3QlMjBvZmZpY2V8ZW58MHx8fHwxNzg5NzE5ODA4fDA&ixlib=rb-4.1.0&q=85",
  clinic: "https://customer-assets-eiarnc6j.emergentagent.net/job_medas-rapido/artifacts/ceptizuq_Randare_11.jpg",
  treatment: "https://images.pexels.com/photos/3845808/pexels-photo-3845808.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  doctorMale: "https://images.unsplash.com/photo-1729162128021-f37dca3ff30d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxmcmllbmRseSUyMHByb2Zlc3Npb25hbCUyMGRvY3RvciUyMGRlbnRpc3QlMjBwb3J0cmFpdCUyMG1lZGljYWwlMjBzdGFmZnxlbnwwfHx8fDE3ODk3MTk4MDV8MA&ixlib=rb-4.1.0&q=85",
  doctorFemale: "https://images.pexels.com/photos/6809667/pexels-photo-6809667.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  doctorTeam: "https://images.pexels.com/photos/37458097/pexels-photo-37458097.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  veneers: "https://images.pexels.com/photos/6627571/pexels-photo-6627571.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  colorMatch: "https://images.pexels.com/photos/3845624/pexels-photo-3845624.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const MARQUEE_ITEMS = [
  "Implantologie 3D", "Alignere Transparente", "Estetică Dentară", "Fațete Ceramice",
  "Endodonție la Microscop", "Igienizare Airflow", "Albire Profesională", "Chirurgie Orală",
];

export const SERVICES = [
  { id: "implantologie", icon: ScanLine, name: "Implantologie 3D", desc: "Un dinte nou, planificat digital și pus cu precizie.", featured: true },
  { id: "igienizare", icon: Droplets, name: "Igienizare & Airflow", desc: "Curățare completă și strălucire, într-o singură ședință." },
  { id: "estetica", icon: Sparkles, name: "Estetică Dentară", desc: "Fațete, albire și un zâmbet care arată natural." },
  { id: "ortodontie", icon: Smile, name: "Ortodonție & Alignere", desc: "Dinți drepți, discret — cu alignere aproape invizibile." },
  { id: "endodontie", icon: Activity, name: "Endodonție la Microscop", desc: "Salvăm dintele natural, blând și fără durere." },
  { id: "pedodontie", icon: Baby, name: "Pedodonție", desc: "Prima vizită la dentist, fără lacrimi și fără frică." },
  { id: "protetica", icon: Crown, name: "Protetică Dentară", desc: "Coroane și lucrări care arată ca dinții tăi." },
  { id: "chirurgie", icon: Scissors, name: "Chirurgie Orală", desc: "Intervenții sigure, cu recuperare ușoară." },
];

export const CASES = [
  { img: "/cazuri/caz1.png", tag: "Estetică dentară", title: "Reabilitare completă a zâmbetului", desc: "De la dinți compromiși la un zâmbet natural și armonios.", contain: true },
  { img: "/cazuri/caz2.png", tag: "Protetică", title: "Coroane și fațete ceramice", desc: "Lucrări ceramice de nediferențiat de dinții naturali.", contain: true },
  { img: "/cazuri/caz3.jpg", video: "/videos/diga.mp4?v=2", tag: "Restaurări", title: "Restaurări estetice din compozit", desc: "Reconstrucții invizibile, într-o singură ședință.", contain: true },
  { img: "/cazuri/chirurgie.jpg", tag: "Chirurgie", title: "Chirurgie orală", desc: "Intervenție precisă, recuperare ușoară.", contain: true },
  { img: "/spatii/cabinet1.jpg", tag: "Implantologie", title: "Implant dentar ghidat 3D", desc: "Dinte lipsă, înlocuit definitiv. Simplu și previzibil." },
  { img: "/cazuri/caz4.jpg", tag: "Estetică dentară", title: "Coroane estetice frontale", desc: "Restaurări vechi, înlocuite cu un zâmbet natural.", contain: true },
];

export const DOCTORS = [
  { id: "alexandra-urda", name: "Dr. Alexandra Urda", role: "Medic Specialist / Fondator", spec: "Protetică", photo: "/doctors/doc3.png", bio: "Fondatoarea clinicii. Protetică de precizie, cu estetică naturală." },
  { id: "robert-tuce", name: "Dr. Robert Tuce", role: "Medic Specialist", spec: "Chirurgie Dento-Alveolară", photo: "/doctors/doc2.png", bio: "Chirurgie precisă, recuperare fără griji." },
  { id: "andreea-boarta", name: "Dr. Andreea Boarta", role: "Medic Specialist", spec: "Endodonție", photo: "/doctors/doc1.png", bio: "Endodonție blândă — dintele natural, salvat." },
  { id: "marius-babucea", name: "Dr. Marius Babucea", role: "Medic Specialist", spec: "Chirurgie Maxilo-Facială", photo: "/doctors/doc4.png", bio: "Chirurgie complexă, abordată cu calm și rigoare." },
  { id: "ovidiu-feres", name: "Dr. Ovidiu Fereș", role: "Medic Specialist", spec: "Protetică", photo: "/doctors/doc5.png", bio: "Protetică impecabilă, în detalii care nu se observă." },
];

export const TESTIMONIALS = [
  { text: "Am fugit de dentist toată viața, dar aici nu am simțit absolut nimic. Implantul a decurs perfect, iar echipa m-a liniștit la fiecare pas.", name: "Andreea M.", city: "Timișoara", initial: "A" },
  { text: "Igienizarea cu airflow a fost o revelație — dinții mei nu au arătat niciodată așa. Recepție impecabilă și programare în aceeași zi.", name: "Cristian D.", city: "Timișoara", initial: "C" },
  { text: "Alignerele transparente mi-au îndreptat dinții fără să observe colegii. Rezultatul final a depășit simularea digitală!", name: "Ioana P.", city: "Giroc", initial: "I" },
  { text: "M-am programat telefonic în câteva secunde. Totul a decurs impecabil, de la recepție până la finalul tratamentului.", name: "Mihai R.", city: "Timișoara", initial: "M" },
  { text: "Doamna doctor a fost extraordinar de răbdătoare cu fiica mea de 6 ani. Acum așteaptă cu bucurie fiecare control.", name: "Elena V.", city: "Dumbrăvița", initial: "E" },
  { text: "Fațetele ceramice mi-au schimbat complet zâmbetul. Aparatură nouă, prețuri clare de la început și rezultat impecabil.", name: "George T.", city: "Timișoara", initial: "G" },
];

export const BOOKING_SERVICES = [
  "Consultație generală", "Igienizare & Airflow", "Implantologie", "Ortodonție & Alignere",
  "Estetică Dentară", "Endodonție", "Pedodonție", "Alt serviciu",
];

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <span className="text-xs font-semibold uppercase tracking-widest text-[#A6823B]">{children}</span>
);
